import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Table, Loading, Form, Input, Space, Button } from 'tdesign-react';
import { useMemoizedFn } from 'ahooks';
import dayjs from 'dayjs';
import { isEmpty, uniqueId } from 'lodash';
import { RefreshIcon } from 'tdesign-icons-react';
import Descriptions from '@/components/Descriptions';
import { renderMillDateTime, renderOptions } from '@/utils/common';
import { boolYesNoOptions, consumptionOptions } from '@/utils/constant';
import useTable from '@/hooks/useTable';
import { getMessageTraceDetail } from '@/services/utilService';
import NoDataCmp from '@/components/NoData';
import ProducerInfo from './ProducerInfo';
import BasicInfo from './BasicInfo';

const { FormItem } = Form;

export default function MessageDeatil({ row }) {
  const [infoData, setInfoData] = useState({});
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);

  const columns = [
    {
      colKey: 'subscriptionName',
      title: '订阅者名称',
      align: 'center',
    },
    {
      colKey: 'subscriptionType',
      align: 'center',
      title: '订阅者模式',
    },
    {
      colKey: 'retryTimes',
      align: 'center',
      title: '重试次数',
    },
    {
      colKey: 'lastDispatchTimestamp',
      align: 'center',
      title: '最后推送时间',
      cell: renderMillDateTime,
      width: 240,
    },
    {
      colKey: 'acked',
      align: 'center',
      title: '是否已消费',
      options: boolYesNoOptions,
      cell: renderOptions,
    },
  ];

  const subColumns = [
    { colKey: 'retryId', width: 100, title: '重试次序' },
    {
      colKey: 'consumerName',
      title: '消费者名称',
      align: 'center',
    },
    {
      colKey: 'consumerAddress',
      align: 'center',
      title: '消费者地址',
    },
    {
      colKey: 'operationTimestamp',
      align: 'center',
      title: '操作时间',
      cell: renderMillDateTime,
      width: 240,
    },
    {
      colKey: 'operationAction',
      align: 'center',
      title: '操作动作',
      cell: renderOptions,
      options: consumptionOptions,
    },
  ];

  const loadData = useMemoizedFn(async (parmas) => {
    setLoading(true);
    try {
      const { data } = await getMessageTraceDetail({
        ...parmas,
        topic: row.topic,
        messageId: row.messageId,
        cluster: row.clusterName,
        batchIndex: row.batchIndex,
      });
      setData(data.subscriptions.map((item) => ({ ...item, key: uniqueId() })));
      setInfoData(data);
    } catch (error) {
      console.trace(error);
      throw error;
    } finally {
      setLoading(false);
    }
  });

  const { header, config, setData, doSearch } = useTable({
    onSearch: loadData,
    columns,
    columnController: null,
    search: (
      <FormItem name='subscription'>
        <Input placeholder='请输入订阅名' clearable />
      </FormItem>
    ),
  });

  useEffect(() => {
    doSearch();
  }, [doSearch]);

  const expandedRow = ({ row }) => {
    const rowData = sortChange(row?.consumers?.map((item) => ({ ...item, key: uniqueId() })));
    return <Table rowKey='key' data={rowData} columns={subColumns} resizable />;
  };

  const onExpandChange = (value) => {
    setExpandedRowKeys(value);
  };

  // 默认排序
  const sortChange = (data) => {
    if (!data) {
      return [];
    }
    const sortData = [...data];
    sortData.sort(function (a, b) {
      const x = dayjs(a.operationTimestamp).valueOf();
      const y = dayjs(b.operationTimestamp).valueOf();
      if (x < y) {
        return -1;
      }
      if (x > y) {
        return 1;
      }
      return 0;
    });
    return sortData;
  };

  return (
    <>
      <Loading loading={loading}>
        <Root>
          <BasicInfo row={row} messageEventTime={infoData.messageEventTime} />
          {isEmpty(infoData) ? (
            <NoData style={{ marginTop: 40 }} tip='暂无数据'>
              <Space align='center' size='small'>
                消息轨迹数据采集有秒级延迟，请稍后点击
                <Button
                  icon={<RefreshIcon />}
                  loading={loading}
                  size='small'
                  onClick={() => loadData()}
                >
                  重试
                </Button>
              </Space>
            </NoData>
          ) : (
            <>
              <ProducerInfo infoData={infoData} />
              <Descriptions title='消费信息'>
                <div>
                  {header}
                  <Table
                    {...config}
                    expandedRow={expandedRow}
                    expandedRowKeys={expandedRowKeys}
                    onExpandChange={onExpandChange}
                    expandOnRowClick={true}
                    rowKey='key'
                  />
                </div>
              </Descriptions>
            </>
          )}
        </Root>
      </Loading>
    </>
  );
}

const Root = styled.div`
  .descriptions {
    margin-top: 16px;
  }
`;

const NoData = styled(NoDataCmp)`
  margin-top: 40px;
  .tip {
    margin-bottom: 10px;
  }
`;
